import EmptyStateComponent from './EmptyStateComponent';

export default EmptyStateComponent;
